document.addEventListener('click', function(e){
  const trigger=e.target.closest('[data-scroll-to]');
  if(trigger){
    const target=document.querySelector(trigger.dataset.scrollTo);
    if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth'});}
  }
});

document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-product-section]').forEach(function(section){
    const thumbs=section.querySelectorAll('[data-media-thumb]');
    const slides=section.querySelectorAll('[data-media-slide]');
    thumbs.forEach(function(btn){btn.addEventListener('click',function(){
      const id=btn.dataset.mediaThumb;
      thumbs.forEach(x=>x.classList.toggle('is-active',x===btn));
      slides.forEach(x=>x.classList.toggle('is-active',x.dataset.mediaSlide===id));
    })});

    const qty=section.querySelector('[data-qty]');
    if(qty){
      const input=qty.querySelector('input');
      qty.querySelector('[data-qty-minus]')?.addEventListener('click',()=>input.value=Math.max(1,(parseInt(input.value)||1)-1));
      qty.querySelector('[data-qty-plus]')?.addEventListener('click',()=>input.value=(parseInt(input.value)||1)+1);
    }

    const variantSelect=section.querySelector('[data-variant-select]');
    const variantsScript=section.querySelector('[data-product-variants]');
    let variants=[];
    try{variants=JSON.parse(variantsScript?.textContent||'[]')}catch(e){}
    const radios=[...section.querySelectorAll('.pp-option-pill input')];
    function syncVariant(){
      if(!variantSelect||!radios.length)return;
      const selected=[];
      const groups=[...new Set(radios.map(r=>r.name))];
      groups.forEach(name=>{const checked=section.querySelector(`input[name="${CSS.escape(name)}"]:checked`);selected.push(checked?.value||'')});
      const match=variants.find(v=>v.options.every((opt,i)=>opt===selected[i]));
      if(match){
        variantSelect.value=String(match.id);
        variantSelect.dispatchEvent(new Event('change',{bubbles:true}));
      }
    }
    radios.forEach(r=>r.addEventListener('change',syncVariant));
    variantSelect?.addEventListener('change',function(){
      const opt=variantSelect.options[variantSelect.selectedIndex];
      const price=opt?.dataset.price;
      const compare=opt?.dataset.compare;
      const priceEl=section.querySelector('[data-current-price]');
      const compareEl=section.querySelector('[data-compare-price]');
      if(priceEl&&price)priceEl.textContent=price;
      if(compareEl)compareEl.textContent=compare||'';
      const mobilePrice=section.querySelector('[data-mobile-price]');if(mobilePrice&&price)mobilePrice.textContent=price;
    });

    const mobileBar=section.querySelector('[data-mobile-atc]');
    const mainAtc=section.querySelector('[data-atc]');
    if(mobileBar&&mainAtc){
      const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>mobileBar.classList.toggle('is-visible',!entry.isIntersecting))},{threshold:.2});
      observer.observe(mainAtc);
      mobileBar.querySelector('[data-mobile-atc-button]')?.addEventListener('click',()=>mainAtc.click());
    }
  });
});
